import React, { useEffect, useRef, useState } from "react";
import { Box, Button, IconButton, Paper } from "@mui/material";
import ClaimTabs from "../../claims/common/ClaimTabs";
import activeResume from "../../../../assets/images/activeResume.svg"
import inactiveResume from "../../../../assets/images/inactiveResume.svg";
import Details from "./details/Details";
import Mileage from "./mileage/Mileage";
import { BorderColorOutlined as BorderColorOutlinedIcon } from "../../../../components/icons";
import {
  OperationsPageShell,
  operationsActionBarSx,
  operationsDetailPaperSx,
} from "../../ifas/components/OperationsUI";
import { useVehicleStore } from "../../../../store/useVehicleStore";

export default function VehicleDetails(props: any) {
  const { viewMode, onHistoryClick } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const { selectedVehicle, setSelectedVehicle } = useVehicleStore();
  const snapshotRef = useRef<any>(null);
  const updateRef = useRef<null | (() => Promise<void>)>(null);
  
  const vehiclePortalTabs = [
    {
      id: 0,
      icon: { active: activeResume, inactive: inactiveResume },
      alt: " Vehicle Details",
    },
    {
      id: 1,
      icon: { active: activeResume, inactive: inactiveResume },
      alt: " Mileage Control",
    },
  ];


  const renderTitle = () => {
    return tabData[activeTab]?.alt || "";
  };

  const tabData = vehiclePortalTabs

  const renderTabContent = () => {
      switch (activeTab) {
        case 0:
          return (
            <Details
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              registerUpdateHandler={(fn) => {
                updateRef.current = fn;
              }}
            />
          );
        case 1:
          return <Mileage />;
      }
    }

  useEffect(() => {
    setActiveTab(0);
    setIsEditing(false);
    snapshotRef.current = null;
  }, [viewMode]);

  const startEdit = () => {
    if (!selectedVehicle) return;
    snapshotRef.current = JSON.parse(JSON.stringify(selectedVehicle));
    setIsEditing(true);
  };

  const cancelEdit = () => {
    if (snapshotRef.current) {
      setSelectedVehicle(snapshotRef.current);
    }
    snapshotRef.current = null;
    setIsEditing(false);
  };

  return (
    <OperationsPageShell
      eyebrow="Vehicle Details"
      title={renderTitle().trim()}
      description="View registration, vehicle type, manufacturer, and assignment status for the selected fleet vehicle."
      actions={
        <Box sx={operationsActionBarSx}>
        <Button
          variant="contained"
          color="secondary"
          onClick={onHistoryClick}
        >
          History
        </Button>
        {!isEditing && (
          <IconButton onClick={startEdit} disabled={!selectedVehicle}>
            <BorderColorOutlinedIcon
              sx={{ cursor: "pointer", color: "black", fontSize: "2rem" }}
            />
          </IconButton>
        )}
        {isEditing && (
          <>
            <Button variant="outlined" color="secondary" onClick={cancelEdit}>
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => updateRef.current?.()}
            >
              Update
            </Button>
          </>
        )}
        </Box>
      }
    >

        {/* <Box display="flex" gap={2} flexWrap={{ xs: "wrap", md: "nowrap" }}>
          {showDropdown &&
            ((role === "consultant" && claimStatus === "DRAFT") ||
              (role === "claim_administrator" && claimStatus === "VETTED") ||
              (role === "claim_manager" && claimStatus === "NEW") ||
              (role === "finance" && claimStatus === "APPROVED") ||
              (role === "underwriter" && claimStatus === "REVIEWED")) && (
              <CustomDropdown
                value={value}
                onChange={handleDropdownChange}
                options={dropdownOptions}
                placeholder="Select Option"
              />
            )}
          {((role === "consultant" && claimStatus === "DRAFT") ||
            (role === "claim_administrator" && claimStatus === "VETTED") ||
            (role === "claim_manager" && claimStatus === "NEW") ||
            (role === "underwriter" && claimStatus === "REVIEWED") ||
            (role === "finance" && claimStatus === "APPROVED")) &&
            isClosable && (
              <ButtonComp
                variant="contained"
                height={40}
                width={150}
                textTransform="none"
                color="secondary"
                onClick={() => setShowCloseClaimPopup(true)}
              >
                Close Claim
              </ButtonComp>
            )}

          {role === "underwriter" && isAssignedToMe && (
            <>
              <ButtonUnderwriter
                onClick={() => setShowClaimApprove(true)}
                icon={checkIcon}
                label="Approve"
                color="#20BF55"
              />
              <ButtonUnderwriter
                onClick={() => setShowRejectDialogue(true)}
                icon={rejectIcon}
                label="Decline"
                color="#E8003F"
              />
            </>
          )}

          {isMobile ? (
            <Tooltip title="History">
              <ButtonComp
                variant="contained"
                height={40}
                width={40}
                color="secondary"
                onClick={onHistoryClick}
              >
                <HistoryIcon />
              </ButtonComp>
            </Tooltip>
          ) : (
            <ButtonComp
              variant="contained"
              height={40}
              width={120}
              textTransform="none"
              color="secondary"
              onClick={onHistoryClick}
            >
              History
            </ButtonComp>
          )}

          {role !== "underwriter" &&
            claimStatus !== "CLOSED" &&
            (showSubmitButton || showSubmit) && (
              <ButtonComp
                variant="outlined"
                height={40}
                width={190}
                textTransform="none"
                onClick={() => {
                  if (isEditable && role === "consultant") {
                    handleUpdate?.();
                  } else {
                    if (role === "claim_manager") {
                      if (isDeathClaim) {
                        setShowManagerSubmitPopup(true);
                      } else if (isChecked) {
                        setShowManagerSubmitPopup(true);
                      } else
                        showInfoToast("Please verify details in legacy system");
                    } else if (role === "finance") {
                      setShowFinanceSubmitPopup(true);
                    } else if (role === "claim_administrator") {
                      onHandleSumbit("admin_submit");
                    } else if (role === "consultant") {
                      if (!isBankingVerified) {
                        showInfoToast("Please verify bank information");
                      } else onHandleSumbit("consultant_submit");
                    } else {
                      onHandleSumbit("consultant_submit");
                    }
                  }
                }}
              >
                {isEditable && role === "consultant" ? "Update" : "Submit"}
              </ButtonComp>
            )}

          {role === "consultant" &&
            claimStatus === "DRAFT" &&
            (assignmentDetails === user_name ||
              isAssignedMeOrSomeone ||
              showSubmitButton) && (
              <BorderColorIcon
                sx={{ cursor: "pointer", color: "black", fontSize: "2rem" }}
                onClick={onEditClick}
              />
            )}
        </Box> */}
      {/* Card Container */}
      <Paper
        sx={operationsDetailPaperSx}
        elevation={0}
      >
        {/* Icons Header */}
        <ClaimTabs
          tabs={tabData}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        {/* Section Title */}
        <Box mt={3}>
          {/* <Box display="flex" flexDirection="row" gap={3}></Box> */}
        {/* Input Grid */}
        {renderTabContent()}
        </Box>
      </Paper>
    </OperationsPageShell>
  );
}
